"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcQuantityByArea = exports.openPanel = exports.isDesktop = exports.getParameterByName = exports.arrayEquals = exports.debounce = void 0;
var config_1 = __importDefault(require("../config"));
function debounce(callback, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate)
                callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            callback.apply(context, args);
    };
}
exports.debounce = debounce;
;
function arrayEquals(a, b) {
    if (a === b)
        return true;
    if (a == null || b == null)
        return false;
    if (a.length !== b.length)
        return false;
    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
exports.arrayEquals = arrayEquals;
function getParameterByName(name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
exports.getParameterByName = getParameterByName;
function isDesktop() {
    return window.matchMedia("(min-width: ".concat(config_1.default.breakpoint.desktop, ")")).matches;
}
exports.isDesktop = isDesktop;
function openPanel(panel, isActive) {
    if (isActive) {
        if (panel)
            panel.style.maxHeight = "".concat(panel.scrollHeight, "px");
    }
    else {
        if (panel)
            panel.style.maxHeight = null;
    }
}
exports.openPanel = openPanel;
function calcQuantityByArea(title, isBinding) {
    var l, w, a, j, quantity;
    var formattedLengths = title.split('x').map(function (length) {
        return length.replace('m', '').trim();
    });
    if (formattedLengths.length > 1) {
        l = parseFloat(formattedLengths[0]) >= parseFloat(formattedLengths[1]) ? parseFloat(formattedLengths[0]) : parseFloat(formattedLengths[1]);
        w = parseFloat(formattedLengths[0]) <= parseFloat(formattedLengths[1]) ? parseFloat(formattedLengths[0]) : parseFloat(formattedLengths[1]);
        if (isBinding) {
            a = (w * 2) + (l * 2);
        }
        else {
            j = Math.ceil(w / 1.7);
            a = j * l;
        }
        quantity = a * 100;
    }
    else {
        quantity = parseInt(formattedLengths[0].replace('.', '')) * 10;
    }
    return Math.ceil(quantity);
}
exports.calcQuantityByArea = calcQuantityByArea;
